(() => {
  const SIZE_OPTION = 'Size';

  const groupsOf = (root) => [...root.querySelectorAll('fieldset, .product-form__input--dropdown')];

  const readValue = (group) =>
    (group.querySelector('input:checked') || group.querySelector('select'))?.value ?? null;

  const optionName = (group) =>
    group.querySelector('[data-option-name]')?.dataset.optionName ?? null;

  const getVariants = (root) => {
    const el =
      root.querySelector('[data-variant-matrix]') ||
      root.querySelector('script[type="application/json"]:not([data-selected-variant])');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  };

  const findVariant = (variants, values) =>
    variants.find((v) => v.options.every((opt, i) => opt === values[i]));

  const setSize = (group, value) => {
    const radios = group.querySelectorAll('input[type="radio"]');
    if (radios.length) {
      radios.forEach((r) => {
        if (r.value === value) r.checked = true;
      });
      return;
    }
    const select = group.querySelector('select');
    if (!select) return;
    [...select.options].forEach((o) => o.toggleAttribute('selected', o.value === value));
    select.value = value;
  };

  const autoSelectSize = (event) => {
    const root = event.target.closest('variant-selects');
    if (!root) return;

    const variants = getVariants(root);
    if (!variants) return;

    const groups = groupsOf(root);
    const sizeIndex = groups.findIndex((g) => optionName(g) === SIZE_OPTION);
    if (sizeIndex === -1) return;

    const selected = groups.map(readValue);
    if (findVariant(variants, selected)?.available) return;

    const target = variants.find(
      (v) => v.available && v.options.every((opt, i) => i === sizeIndex || opt === selected[i])
    );
    if (target) setSize(groups[sizeIndex], target.options[sizeIndex]);
  };

  const money = (cents) => {
    const shop = window.Shopify;
    if (!shop?.currency?.active) return null;
    return new Intl.NumberFormat(shop.locale || undefined, {
      style: 'currency',
      currency: shop.currency.active,
    }).format(cents / 100);
  };

  const quantityOf = (scope) => {
    const qty = parseInt(scope.querySelector('.quantity__input, input[name="quantity"]')?.value, 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  };

  const updatePrice = (scope) => {
    const root = scope.querySelector('variant-selects');
    if (!root) return;

    const variants = getVariants(root);
    if (!variants) return;

    const variant = findVariant(variants, groupsOf(root).map(readValue));
    const target = scope.querySelector('.atc-price__amount') || scope.querySelector('.atc-price');
    if (!variant || !target) return;

    const formatted = money(variant.price * quantityOf(scope));
    if (formatted) target.textContent = formatted;
  };

  const scopeOf = (el) => el.closest('product-info') || document;

  const isPriceTrigger = (t) =>
    t.closest('variant-selects') || t.matches('.quantity__input, input[name="quantity"]');

  document.addEventListener('change', autoSelectSize, true);

  document.addEventListener('change', (e) => {
    if (isPriceTrigger(e.target)) updatePrice(scopeOf(e.target));
  });

  document.addEventListener('input', (e) => {
    if (e.target.matches('.quantity__input, input[name="quantity"]')) updatePrice(scopeOf(e.target));
  });

  const init = () => document.querySelectorAll('product-info').forEach(updatePrice);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();